import { useTranslation } from "react-i18next";

// Shown above the Bosnian legal text when an English reader chose to read it,
// so there is a way back. Same look as TranslationNotice; it changes the view
// of this page only, never the site or account language.
export default function BosnianViewNotice({ onReadEnglish }) {
	const { t } = useTranslation();

	return (
		<aside role="note" className="mb-6 rounded-md border p-4 text-sm">
			<button type="button" className="underline" onClick={onReadEnglish}>
				{t("common:legal.readEnglish")}
			</button>
		</aside>
	);
}
